import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { shopApi } from "./shopApi";

export const useProductCardSettings = () => {
  const queryClient = useQueryClient();

  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.PRODUCT_CARD_SETTINGS(),
    queryFn: () => shopApi.fetchProductCardSettings(),
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.PRODUCT_CARD_SETTINGS(),
    });
  };

  return {
    isLoading,
    isFetching,
    productCardSettings: data?.data,
    invalidate,
  };
};
